const collectText = (value: unknown): string => {
  if (!value) return ''
  if (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean') return String(value)
  if (Array.isArray(value)) return value.map(collectText).join(' ')
  if (typeof value === 'object')
    return Object.values(value as Record<string, unknown>)
      .map(collectText)
      .join(' ')
  return ''
}

export const isAccountLockedPayload = (payload: unknown): boolean => {
  const text = collectText(payload).toLowerCase()
  return (
    text.includes('account_locked') ||
    text.includes('account locked') ||
    text.includes('заблокирован') ||
    text.includes('заблокирована')
  )
}

export const PASSWORD_EXPIRED_EVENT = 'password-expired'
export const ACCOUNT_LOCKED_EVENT = 'account-locked'

export const isPasswordExpiredPayload = (payload: unknown): boolean => {
  const text = collectText(payload).toLowerCase()
  return (
    text.includes('password_expired') || text.includes('password expired') || text.includes('необходимо сменить пароль')
  )
}
